/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import xlsx from 'xlsx';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';
import { GetTableFooter } from '../../../_component/tableFooter';

export function AdminAuthor() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [author] = useState<string>('author');
  const [items, setItems] = useState<any[]>([]);
  const [meta, setMeta] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [searchText, setSearchText] = useState<string>('');
  const [searchSelect, setSearchSelect] = useState<string>('title');
  const [excelLoading, setExcelLoading] = useState<string>('(준비중)');
  const [excelData, setExcelData] = useState<any>([
    {
      id: '',
      name: '',
      username: '',
      phone: '',
      email: '',
      part: '',
      address: '',
      college: '',
      department: '',
      date: '',
    },
  ]);
  const excelDataEmpty = [
    {
      id: '',
      name: '',
      username: '',
      phone: '',
      email: '',
      part: '',
      address: '',
      college: '',
      department: '',
      date: '',
    },
  ];

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getUsers();
  }, [currentPage]);

  // 검색 아이콘 클릭 시
  const onClickSearch = () => {
    setCurrentPage(1);
    getUsers();
  };

  // API 호출
  const getUsers = async () => {
    if (searchText.length === 0) {
      await server
        .getUsersPart(currentPage, 10, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .getUsersPart(1, payload.meta.totalItems, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else if (searchSelect === 'name') {
      await server
        .searchUserRealName(currentPage, 10, searchText, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .searchUserRealName(1, payload.meta.totalItems, searchText, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else if (searchSelect === 'id') {
      await server
        .searchUserId(currentPage, 10, searchText, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .searchUserId(1, payload.meta.totalItems, searchText, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else if (searchSelect === 'college') {
      await server
        .searchUserCollege(currentPage, 10, searchText, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .searchUserCollege(1, payload.meta.totalItems, searchText, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else if (searchSelect === 'dept') {
      await server
        .searchUserDept(currentPage, 10, searchText, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .searchUserDept(1, payload.meta.totalItems, searchText, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .searchUser(currentPage, 10, searchText, author)
        .then(async (payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setMeta(payload.meta);
            await server
              .searchUser(1, payload.meta.totalItems, searchText, author)
              .then((payload2) => {
                if (payload2.items.length !== 0) {
                  dataExcelInput(payload2);
                } else {
                  setExcelData(excelDataEmpty);
                  setExcelLoading('(준비완료)');
                }
              })
              .catch((error) => {
                dispatch(
                  toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
                );
                console.log(error);
              });
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 회원 구분(일반/교수/저자/관리자) 체크박스 클릭 시
  const handleClickCheckbox = async (id: any, partText: any) => {
    await server
      .patchUser(id.toString(), {
        part: partText,
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: `서버로부터 응답이 없습니다.` }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: `파라미터 오류` }));
        } else {
          dispatch(toast.info({ message: '해당 회원의 구분이 변경되었습니다.' }));
          getUsers();
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 데이터값 가져오기
  const usersRow = items?.map((item: any) => (
    <ul className="row" key={item.id}>
      <li className="counter">{item.id}</li>
      <li className="user-name">{item.name}</li>
      <li className="user-id">{item.username}</li>
      <li className="phone">{item.phone}</li>
      <li className="email">{item.email}</li>
      <li className="address">
        주소 : {item.address}
        <br />
        학교명 : {item.college}
        <br />
        학과 : {item.department}
      </li>
      <li className="date">
        {new Date(item.modDate).toLocaleDateString()}
        <br />({new Date(item.lastDate).toLocaleDateString()})
      </li>
      <li className="buttons">
        <div className="radio">
          <input
            type="radio"
            id={`${item.id}-normal`}
            name={item.username}
            defaultChecked={item.part === `normal`}
            onClick={() => handleClickCheckbox(item.id, 'normal')}
          />
          <label htmlFor={`${item.id}-normal`}> 일반</label>
        </div>
        <div className="radio">
          <input
            type="radio"
            id={`${item.id}-professor`}
            name={item.username}
            defaultChecked={item.part === `professor`}
            onClick={() => handleClickCheckbox(item.id, 'professor')}
          />
          <label htmlFor={`${item.id}-professor`}> 교수</label>
        </div>
        <div className="radio">
          <input
            type="radio"
            id={`${item.id}-author`}
            name={item.username}
            defaultChecked={item.part === `author`}
            onClick={() => handleClickCheckbox(item.id, 'author')}
          />
          <label htmlFor={`${item.id}-author`}> 저자</label>
        </div>
        <button
          className="btn-delete"
          id={item.id}
          type="button"
          onClick={() => {
            deleteUser(item.id);
          }}
        >
          계정삭제
        </button>
      </li>
    </ul>
  ));

  // 회원 삭제
  const deleteUser = (deleteId: string) => {
    if (window.confirm('해당 계정삭제를 진행하시겠습니까?') === true) {
      dispatch(toast.info({ message: '해당 계정이 삭제되었습니다.' }));
      server.deleteUser(deleteId).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          getUsers();
        }
      });
    } else {
      console.log('');
    }
  };

  // 엑셀 저장하기 버튼 클릭 시
  const onClickExcel = async () => {
    const ws = xlsx.utils.json_to_sheet(excelData);
    const wb = xlsx.utils.book_new();
    [
      '번호',
      '이름',
      'ID',
      '전화번호',
      '이메일',
      '구분',
      '주소',
      '대학명',
      '학과명',
      '회원등록일',
    ].forEach((x, idx) => {
      const cellAdd = xlsx.utils.encode_cell({ c: idx, r: 0 });
      ws[cellAdd].v = x;
    });
    xlsx.utils.book_append_sheet(wb, ws, 'sheet1');
    xlsx.writeFile(wb, 'member-author.xlsx');
  };

  // API로 호출한 데이터를 엑셀에 넣기
  const dataExcelInput = (data: any) => {
    const dataArray = [];
    let userPart = '';
    for (let i = 0; data.items.length > i; i++) {
      if (data.items[i].part === 'normal') {
        userPart = '일반';
      }
      if (data.items[i].part === 'professor') {
        userPart = '교수';
      }
      if (data.items[i].part === 'author') {
        userPart = '저자';
      }
      dataArray[i] = {
        id: data.items[i].id,
        name: data.items[i].name,
        username: data.items[i].username,
        phone: data.items[i].phone,
        email: data.items[i].email,
        part: userPart,
        address: data.items[i].address,
        college: data.items[i].college,
        department: data.items[i].department,
        date: new Date(data.items[i].modDate).toLocaleDateString(),
      };
    }
    setExcelData(dataArray);
    setExcelLoading('(준비완료)');
  };

  // 테이블 헤더
  function createTableHeader() {
    return (
      <div className="table-header">
        <div className="search">
          <div className="selectbox">
            <select
              name=""
              id=""
              value={searchSelect}
              onChange={(event) => {
                setSearchSelect(event.target.value);
              }}
            >
              <option value="all">{searchSelect === 'all'}전체</option>
              <option value="name">{searchSelect === 'name'}이름</option>
              <option value="id">{searchSelect === 'id'}ID</option>
              <option value="college">{searchSelect === 'college'}학교명</option>
              <option value="dept">{searchSelect === 'dept'}학과</option>
            </select>
          </div>
          <input
            type="text"
            value={searchText}
            onChange={(dom) => {
              setSearchText(dom.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                onClickSearch();
              }
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClickSearch}
            width="18"
            height="18"
            viewBox="0 0 24 24"
          >
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
        </div>
      </div>
    );
  }

  // user 리스트
  function createUserList() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="counter">번호</li>
          <li className="user-name">이름</li>
          <li className="user-id">ID</li>
          <li className="phone">전화번호</li>
          <li className="email">이메일</li>
          <li className="address">상세정보</li>
          <li className="date">회원등록일</li>
        </ul>
        {usersRow}
      </div>
    );
  }

  // 미사용
  const onClick = () => {};

  // AdminAuthor 리턴값
  return (
    <main className="list-user wrapper">
      <div className="title">
        <h1>저자 회원 현황</h1>
        <div className="buttons">
          <button type="button" onClick={onClickExcel}>
            엑셀파일로 저장 {excelLoading}
          </button>
        </div>
      </div>
      <div className="content">
        {createTableHeader()}
        {createUserList()}
        {GetTableFooter(
          meta?.currentPage,
          meta?.totalPages,
          (page: number) => setCurrentPage(page),
          '',
          onClick,
          false
        )}
      </div>
    </main>
  );
}
